import {
  IPendingWithholding,
  IPendingWithholdingCreate
} from "@wingspanhq/bookkeeping/dist/lib/interfaces";
import { WSMutationsConfig } from "@ws-react-query";
import bookkeepingService from "../../services/bookkeeping";
import { WSServiceError } from "../../utils/serviceHelper";
import { QUERY_LIST_INTERNAL_ACCOUNT_TRANSACTIONS } from "../banking/queries/useQueryListInternalAccountTransactions";
import { useWSMutation } from "../helpers";

export const useCreatePendingWithholding = (
  config?: WSMutationsConfig<
    IPendingWithholding,
    WSServiceError,
    IPendingWithholdingCreate
  >
) =>
  useWSMutation(
    async (request: IPendingWithholdingCreate) =>
      await bookkeepingService.createPendingWithholding(request),
    {
      awaitDependencies: [QUERY_LIST_INTERNAL_ACCOUNT_TRANSACTIONS],
      ...config
    }
  );
